import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Dropdown, Button, Icon} from 'semantic-ui-react';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {pageSizes} from '../../../common/constants/lists';
import {downloadFile} from '../../../common/util/file';
import {Actions} from '../../../common/actions';
import BackOrdersTable from './table';
import BackOrdersFilters from './filters';
import './backOrdersList.scss';

class BackOrdersReport extends Component {
  constructor(props) {
    super(props);
    this.state = {'invoice': ''};
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.BackOrdersReport, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchPendingInvoicesToBin('backOrders');
  }

  componentDidUpdate(prevProps) {
    const {urlBackOrders} = this.props;
    if (urlBackOrders && prevProps.urlBackOrders !== urlBackOrders) {
      downloadFile(urlBackOrders);
    }
  }

  getInvoices() {
    return this.props.invoices.map((item) => {
      return {'text': item.invoice, 'value': item.invoice};
    });
  }

  changeInvoice(value) {
    this.setState({'invoice': value});
    this.props.clearUrlBackOrders();
  }

  onRefreshClick() {
    this.setState({'invoice': ''});
    this.props.fetchPendingInvoicesToBin('backOrders');
    this.props.clearTextFilter();
    this.props.clearBackOrdersList();
  }

  onFindClick() {
    this.props.changeBackOrdersListPage(0);
    this.props.changeBackOrdersListPageSize(pageSizes[0].value);
    this.props.fetchBackOrdersByInvoice(this.state.invoice);
  }

  onDownloadClick() {
    this.props.downloadBackOrdersByInvoice(this.state.invoice);
  }

  renderDownloadIcon() {
    const {loadingBackOrders, downloading} = this.props;
    return (
      <Button
        type='button'
        primary
        className='toyota-primary download'
        disabled={!this.state.invoice || loadingBackOrders || downloading}
        loading={downloading}
        onClick={this.onDownloadClick.bind(this)}
      >
        <Icon name='download' />
        Excel
      </Button>
    );
  }

  render() {
    const {loadingBackOrders, loadingInvoices, downloading} = this.props;
    return (
      <div className='back-orders-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Reporte Back Orders</h2>
              <div className='title-bar-actions'>
                <Dropdown
                  selection
                  options={this.getInvoices()}
                  search
                  value={this.state.invoice}
                  disabled={loadingInvoices}
                  loading={loadingInvoices}
                  onChange={(e, {value}) => this.changeInvoice(value)}
                  placeholder='Seleccione Factura'
                  noResultsMessage='No se encontraron facturas'
                />

                <Button
                  type='button'
                  primary
                  className='toyota-primary refresh'
                  onClick={this.onRefreshClick.bind(this)}
                >
                  <Icon name='refresh' size='large' />
                </Button>

                <Button
                  type='button'
                  primary
                  className='toyota-primary'
                  disabled={!this.state.invoice || loadingBackOrders || downloading}
                  onClick={this.onFindClick.bind(this)}
                >
                  Buscar
                </Button>
                {this.renderDownloadIcon()}
              </div>
            </div>
            <div className='subtitle'>
              Puede realizar la búsqueda ingresando uno o más de los siguientes
              parámetros:
            </div>
            <div className='search'>
              <BackOrdersFilters />
            </div>
          </div>
        </Card>
        <BackOrdersTable />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingInvoices': state.backOrders.loadingInvoices,
    'invoices': state.backOrders.listInvoices,
    'loadingBackOrders': state.backOrders.loadingBackOrders,
    'backOrders': state.backOrders.page,
    'pageNumber': state.backOrders.pageNumber,
    'pageSize': state.backOrders.pageSize,
    'totalItems': state.backOrders.filteredList.length,
    'downloading': state.backOrders.downloading,
    'urlBackOrders': state.backOrders.urlBackOrders,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  fetchPendingInvoicesToBin,
  fetchBackOrdersByInvoice,
  downloadBackOrdersByInvoice,
  clearUrlBackOrders,
  changeBackOrdersListPage,
  changeBackOrdersListPageSize,
  clearBackOrdersList,
  clearTextFilter,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchPendingInvoicesToBin,
  fetchBackOrdersByInvoice,
  downloadBackOrdersByInvoice,
  clearUrlBackOrders,
  changeBackOrdersListPage,
  changeBackOrdersListPageSize,
  clearBackOrdersList,
  clearTextFilter,
  navigateTo,
})(BackOrdersReport);
